import React from 'react';

import appleSvg from 'common/assets/images/apple.svg';
import { useLocalization } from 'common/providers/LocaleProvider';
import { useAppleSignIn } from './hooks/apple-sign-in';
import type { PerformLogin } from './hooks/third-party-login';
import ThirdPartyButton from './ThirdPartyButton';

interface AppleButtonProps {
  clientId: string;
  stateToken: string;
  performLogin: PerformLogin;
  setCommonError: () => void;
  placement?: string;
  isDisabled?: boolean;
}

const AppleButton = ({
  clientId,
  placement,
  isDisabled,
  stateToken,
  performLogin,
  setCommonError,
}: AppleButtonProps) => {
  const { r } = useLocalization();
  const { isLoading, signIn } = useAppleSignIn({
    clientId,
    placement,
    stateToken,
    onAppleAuth: performLogin,
    setCommonError,
  });

  return (
    <ThirdPartyButton
      label={r.t('h24_social_sign_in_label', { provider: 'Apple' })}
      isLoading={isLoading}
      imgSrc={appleSvg}
      onClick={signIn}
      isDisabled={isDisabled}
    />
  );
};

export default AppleButton;
